import { Link } from 'react-router-dom';
import { MapPin, Package, Clock, ArrowRight } from 'lucide-react';
import Footer from '../../components/Footer';

const Projects = () => {
  const projects = [
    {
      title: 'Distribution Centre Racking',
      location: 'Germiston',
      scope: '2,400 pallet positions',
      result: 'Installed within days',
      image: '/project_01.jpg',
      description: 'Complete warehouse racking system for a major logistics company, featuring selective pallet racking with 4,000kg capacity per level.',
    },
    {
      title: 'Archive Shelving',
      location: 'Germiston',
      scope: '1,200 linear meters',
      result: 'Fire-rated finish',
      image: '/project_02.jpg',
      description: 'Custom shelving solution for government archive facility with specialized fire-rated materials and organized filing system.',
    },
    {
      title: 'Production Mezzanine',
      location: 'Germiston',
      scope: '450m² floor',
      result: 'Building control approved',
      image: '/project_03.jpg',
      description: 'Two-level mezzanine floor installed in a manufacturing facility to double production space without relocation.',
    },
  ];

  return (
    <div className="pt-20">
      {/* Header */}
      <section className="w-full bg-charcoal py-20 lg:py-32">
        <div className="px-6 lg:px-[7vw]">
          <h1 className="font-display font-bold text-white text-4xl lg:text-6xl mb-4">
            Built to Perform.
          </h1>
          <p className="text-white/60 max-w-2xl text-lg">
            A selection of recent installs—designed for real loads, real deadlines, real results.
          </p>
        </div>
      </section>

      {/* Projects */}
      <section className="w-full bg-offwhite py-16 lg:py-24">
        <div className="px-6 lg:px-[7vw]">
          <div className="space-y-16">
            {projects.map((project, index) => (
              <div
                key={index}
                className={`flex flex-col ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'
                } gap-8 lg:gap-12 items-center bg-white rounded-2xl overflow-hidden shadow-sm`}
              >
                <div className="w-full lg:w-1/2">
                  <div className="aspect-video">
                    <img
                      src={project.image}
                      alt={project.title}
                      width="800"
                      height="450"
                      loading="lazy"
                      decoding="async"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="w-full lg:w-1/2 p-6 lg:p-8">
                  <h3 className="font-display font-bold text-charcoal text-2xl lg:text-3xl mb-3">
                    {project.title}
                  </h3>
                  <p className="text-charcoal/60 mb-6">{project.description}</p>
                  <div className="space-y-3 mb-6">
                    <div className="flex items-center gap-3 text-charcoal/70">
                      <MapPin className="w-5 h-5 text-lime" />
                      <span>{project.location}</span>
                    </div>
                    <div className="flex items-center gap-3 text-charcoal/70">
                      <Package className="w-5 h-5 text-lime" />
                      <span>{project.scope}</span>
                    </div>
                    <div className="flex items-center gap-3 text-charcoal/70">
                      <Clock className="w-5 h-5 text-lime" />
                      <span>{project.result}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="w-full bg-charcoal py-16">
        <div className="px-6 lg:px-[7vw] text-center">
          <h2 className="font-display font-bold text-white text-2xl lg:text-3xl mb-4">
            Have a project in mind?
          </h2>
          <p className="text-white/60 max-w-xl mx-auto mb-6">
            We'd love to hear about your storage needs. Get in touch for a free consultation and quote.
          </p>
          <Link to="/contact" className="bg-lime text-charcoal px-8 py-4 rounded-lg font-medium inline-flex items-center gap-2 hover:bg-lime/90 transition-colors">
            Start Your Project
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Projects;
